import React, { useState, useEffect,useRef,useCallback  } from 'react';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
import Snackbar from '@mui/material/Snackbar';
import Chip from "@mui/material/Chip";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Alert,
  Stack
} from '@mui/material';
import HeaderMenu from '../Header/HeaderMenu';

const INITIAL_DAILY_MENU = {
  Monday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Tuesday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Wednesday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Thursday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Friday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Saturday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
  Sunday: { breakfast: '', lunch: '', snacks: '', dinner: '' },
};
const INITIAL_SERVING_TIME = {
  breakfast: { from: "", to: "" },
  lunch: { from: "", to: "" },
  snacks: { from: "", to: "" },
  dinner: { from: "", to: "" }
};

const CreateHostelMenu = ({ isDialog, onClose, location, hostel }) => {

  const [formState, setFormState] = useState({
    hostelName: '',
    location: '',
    contactNumber: '',
    servingTime: INITIAL_SERVING_TIME,   // <-- ADDED HERE ★
    dailyMenu: INITIAL_DAILY_MENU,
    foodCost: {
      oneDay: '',
      oneMonth: '',
      closureFoodAdjustmentPerDay: '',
      absentFoodAdjustmentPerDay: '',
    },
  });
const [defaultMenu, setDefaultMenu] = useState({
  breakfast: "",
  lunch: "",
  snacks: "",
  dinner: ""
});
  const [hostelList, setHostelList] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const alertRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [menuType, setMenuType] = useState("WEEKLY");
  const [menuTypeLoading, setMenuTypeLoading] = useState(false);
  const [propertyType, setPropertyType] = useState("");
// Today's Add-On Items
const [addOnItems, setAddOnItems] = useState([
  { name: '', price: '' }
]);
const [openSnackbar, setOpenSnackbar] = useState(false);
  // Fetch hostel names
  useEffect(() => {
    axiosApi
      .post('/hostel/getHostelName', {})
      .then((response) => {
        const hostelArray = Array.isArray(response.data)
          ? response.data
          : response.data.hostels || [];
        setHostelList(hostelArray);
      })
      .catch((error) => console.error('Error fetching hostels:', error));
  }, []);

  // Populate form if editing
  useEffect(() => {
  if (hostel) {
    setFormState({
      hostelName: hostel.hostelName || '',
      location: hostel.location || '',
      contactNumber: hostel.contactNumber || '',

      servingTime: hostel.servingTime || INITIAL_SERVING_TIME,   // 🔥 FIX ADDED

      dailyMenu: hostel.dailyMenu || INITIAL_DAILY_MENU,

      foodCost: hostel.foodCost || {
        oneDay: '',
        oneMonth: '',
        closureFoodAdjustmentPerDay: '',
        absentFoodAdjustmentPerDay: '',
      },
    });
  }
}, [hostel]);
const fetchStandardMenu = useCallback(async (hostelId) => {
  try {
    const response = await axiosApi.post(
      "/hostelMenu/getHostelStandardMenu",
      {
        hostelIds: [hostelId]
      }
    );

    const data = Array.isArray(response.data)
      ? response.data[0]
      : response.data;

    setDefaultMenu({
  breakfast: data?.breakfast || "",
  lunch: data?.lunch || "",
  snacks: data?.snacks || "",
  dinner: data?.dinner || ""
});
  } catch (error) {
    console.error(error);

    setDefaultMenu({
      breakfast: "",
      lunch: "",
      snacks: "",
      dinner: ""
    });
  }
}, []);
const fetchHostelMenuType = useCallback(async (hostelId) => {
  try {
    setMenuTypeLoading(true);

    const searchCriteria = {
      hostelSearchCriteria: {
        hostelIds: [hostelId]
      }
    };

    const response = await axiosApi.post(
      "/hostel/getHostels",
      searchCriteria
    );

    const hostelData =
      response.data?.hostels?.[0] ||
      response.data?.[0];
setPropertyType(
  hostelData?.propertyType?.toUpperCase() || ""
);
    const type =
      hostelData?.menuType?.toUpperCase() ||
      "WEEKLY";

    setMenuType(type);

    if (type === "STANDARD") {
      fetchStandardMenu(hostelId);
    }
  } catch (error) {
    console.error(error);
    setMenuType("WEEKLY");
  } finally {
    setMenuTypeLoading(false);
  }
}, [fetchStandardMenu]);
  // Fetch menu and food cost when hostel changes
  useEffect(() => {
    if (!formState.hostelName) return;

    const selected = hostelList.find((h) => h[1] === formState.hostelName);
    const selectedHostelId = selected ? selected[0] : null;
    if (!selectedHostelId) return;
fetchHostelMenuType(selectedHostelId);
    // Fetch Daily Menu
    axiosApi
      .post('/hostelMenu/getHostelMenu', { hostelIds: [selectedHostelId] })
      .then((response) => {
        const apiMenu = response.data;
        const transformedMenu = { ...INITIAL_DAILY_MENU };
        apiMenu.forEach((item) => {
          transformedMenu[item.dayOfWeek] = {
            breakfast: item.breakfastItems || '',
            lunch: item.lunchItems || '',
            snacks: item.snacksItems || '',
            dinner: item.dinnerItems || '',
          };
        });
        setFormState((prev) => ({ ...prev, dailyMenu: transformedMenu }));
      })
      .catch((error) => console.error('Error fetching menu:', error));

    // Fetch Food Cost
    axiosApi
      .post('/hostelFoodCost/getHostelFoodCost', { hostelIds: [selectedHostelId] })
      .then((response) => {
        const costArray = response.data;
        if (Array.isArray(costArray) && costArray.length > 0) {
          const cost = costArray[0];
          setFormState((prev) => ({
            ...prev,
            foodCost: {
              oneDay: cost.foodPricePerDay ?? '',
              oneMonth: cost.foodPricePerMonth ?? '',
              closureFoodAdjustmentPerDay: cost.closureFoodAdjustmentPerDay ?? '',
              absentFoodAdjustmentPerDay: cost.absentFoodAdjustmentPerDay ?? '',
			 
            },
			
			servingTime: {
        breakfast: { from: cost.breakfastFrom ?? '', to: cost.breakfastTo ?? '' },
        lunch: { from: cost.lunchFrom ?? '', to: cost.lunchTo ?? '' },
        snacks: { from: cost.snacksFrom ?? '', to: cost.snacksTo ?? '' },
        dinner: { from: cost.dinnerFrom ?? '', to: cost.dinnerTo ?? '' }
      }
          }));
        } else {
          setFormState((prev) => ({
            ...prev,
            foodCost: {
              oneDay: '',
              oneMonth: '',
              closureFoodAdjustmentPerDay: '',
              absentFoodAdjustmentPerDay: '',
            },
			servingTime: {
        breakfast:{from:'',to:''},
        lunch:{from:'',to:''},
        snacks:{from:'',to:''},
        dinner:{from:'',to:''},
      }
          }));
        }
      })
      .catch((error) => console.error('Error fetching food cost:', error));
	  
	  
	  /* =======================
     3. ✅ Fetch Add-On Menu Items
     ======================= */
  axiosApi
    .post('/hostelMenu/getHostelAddOnMenuItem', {
      hostelIds: [selectedHostelId],
    })
    .then((response) => {
      const addOns = response.data || [];

      setAddOnItems(
        addOns.length > 0
          ? addOns.map(item => ({
              name: item.itemName || '',
              price: item.itemPrice || ''
            }))
          : [{ name: '', price: '' }]
      );
    })
    .catch(() => {
      setAddOnItems([{ name: '', price: '' }]);
    });
	
  }, [formState.hostelName, hostelList,fetchHostelMenuType]);





useEffect(() => {
  if (successMessage || errorMessage) {
    const timer = setTimeout(() => {
      alertRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      alertRef.current?.focus();
    }, 100);

    return () => clearTimeout(timer);
  }
}, [successMessage, errorMessage]);

  const handleChange = (event) => {
    const { name, value } = event.target;
	setMenuTypeLoading(true);
setMenuType("");
   if (name === 'hostelName') {
  setFormState((prev) => ({
    ...prev,
    hostelName: value,
    dailyMenu: structuredClone(INITIAL_DAILY_MENU),
    foodCost: {
      oneDay: '',
      oneMonth: '',
      closureFoodAdjustmentPerDay: '',
      absentFoodAdjustmentPerDay: ''
    },
    servingTime: structuredClone(INITIAL_SERVING_TIME)
  }));

  setAddOnItems([{ name: '', price: '' }]);

  

  setDefaultMenu({
    breakfast: "",
    lunch: "",
    snacks: "",
    dinner: ""
  });
} else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }
  };
  
 

  const handleMenuChange = (day, meal, value) => {
    setFormState((prev) => ({
      ...prev,
      dailyMenu: { ...prev.dailyMenu, [day]: { ...prev.dailyMenu[day], [meal]: value } },
    }));
  };
const handleServingTimeChange = (meal, field, value) => {
  setFormState(prev => ({
    ...prev,
    servingTime: {
      ...prev.servingTime,
      [meal]: {
        ...prev.servingTime[meal],
        [field]: value
      }
    }
  }));
};
  const handleCostChange = (event, period) => {
    const { value } = event.target;
    setFormState((prev) => ({ ...prev, foodCost: { ...prev.foodCost, [period]: value } }));
  };



const handleSubmit = async (event) => {
  event.preventDefault();

  setSuccessMessage('');
  setErrorMessage('');

  const selectedHostel = hostelList.find(
    (h) => h[1] === formState.hostelName
  );

  const selectedHostelId = selectedHostel
    ? selectedHostel[0]
    : null;

  if (!selectedHostelId) {
    setErrorMessage('Please select a hostel.');
    return;
  }

  // Validate Add-On Items
  const validAddOns = addOnItems.filter(
    item => item.name.trim() && item.price
  );

  const invalidAddOns = addOnItems.filter(
    item =>
      (item.name.trim() && !item.price) ||
      (!item.name.trim() && item.price)
  );

  if (invalidAddOns.length > 0) {
    setErrorMessage(
      'Each Add-On item must contain both Name and Price.'
    );
    return;
  }

  const addOnItemDTOs = validAddOns.map(item => ({
    hostelId: selectedHostelId,
    itemName: item.name.trim(),
    itemPrice: Number(item.price)
  }));
setSaving(true);
  try {

    // =========================
    // WEEKLY MENU SAVE
    // =========================
    if (menuType === "WEEKLY") {

      const hostelMenuDTOs = Object.keys(
        formState.dailyMenu
      ).map((day) => ({
        hostelId: selectedHostelId,
        dayOfWeek: day,
        breakfastItems:
          formState.dailyMenu[day].breakfast || '',
        lunchItems:
          formState.dailyMenu[day].lunch || '',
        snacksItems:
          formState.dailyMenu[day].snacks || '',
        dinnerItems:
          formState.dailyMenu[day].dinner || '',
      }));

      const requestPayload = {
        hostelNames: [formState.hostelName],
        hostelIds: [selectedHostelId],
        hostelMenuIds: [],
        hostelMenuDTOs,
        hostelAddOnMenuItemDTOs: addOnItemDTOs
      };

      await axiosApi.post(
        '/hostelMenu/updateHostelMenu',
        requestPayload
      );

      setSuccessMessage(
        'Weekly menu saved successfully!'
      );
	  setOpenSnackbar(true);
    }

    // =========================
    // STANDARD MENU SAVE
    // =========================
    else if (menuType === "STANDARD") {

  const requestPayload = {
   hostelStandardMenuDTO: {
  hostelId: selectedHostelId,
  breakfast: defaultMenu.breakfast,
  lunch: defaultMenu.lunch,
  snacks: defaultMenu.snacks,
  dinner: defaultMenu.dinner
},
    hostelAddOnMenuItemDTOs: addOnItemDTOs
  };

  await axiosApi.post(
    '/hostelMenu/updateHostelStandardMenu',
    requestPayload
  );

  setSuccessMessage(
    'Standard menu saved successfully!'
  );
}

  } catch (error) {
    console.error(error);
    setErrorMessage(
      'Failed to save menu. Please try again.'
    );
  }
  finally{
   setSaving(false);
}
};

 const handleFoodCostUpdate = async () => {
  setSuccessMessage('');
  setErrorMessage('');

  const selected = hostelList.find((h) => h[1] === formState.hostelName);
  const selectedHostelId = selected ? selected[0] : null;

  if (!selectedHostelId) {
    return setErrorMessage('Please select a hostel first.');
  }

  // Convert time to comparable minute value
  const toMinutes = (t) => {
    if (!t) return 0;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };


  // VALIDATION BLOCK ⛔
  const validations = [
    { name: "Breakfast", from: formState.servingTime.breakfast.from, to: formState.servingTime.breakfast.to },
    { name: "Lunch",     from: formState.servingTime.lunch.from,     to: formState.servingTime.lunch.to },
    { name: "Snacks",    from: formState.servingTime.snacks.from,    to: formState.servingTime.snacks.to },
    { name: "Dinner",    from: formState.servingTime.dinner.from,    to: formState.servingTime.dinner.to }
  ];

  for (let meal of validations) {
    if (meal.from && meal.to && toMinutes(meal.from) >= toMinutes(meal.to)) {
      return setErrorMessage(`${meal.name} "From" time must be earlier than "To" time`);
    }
  }

  try {
    const payload = {
      hostelId: selectedHostelId,
      hostelFoodCostDTO: {
        hostelId: selectedHostelId,
        foodPricePerDay: Number(formState.foodCost.oneDay),
        foodPricePerMonth: Number(formState.foodCost.oneMonth),
        closureFoodAdjustmentPerDay: Number(formState.foodCost.closureFoodAdjustmentPerDay),
        absentFoodAdjustmentPerDay: Number(formState.foodCost.absentFoodAdjustmentPerDay),

        breakfastFrom: formState.servingTime.breakfast.from,
        breakfastTo:   formState.servingTime.breakfast.to,

        lunchFrom: formState.servingTime.lunch.from,
        lunchTo:   formState.servingTime.lunch.to,

        snacksFrom: formState.servingTime.snacks.from,
        snacksTo:   formState.servingTime.snacks.to,

        dinnerFrom: formState.servingTime.dinner.from,
        dinnerTo:   formState.servingTime.dinner.to
      }
    };

    await axiosApi.post('/hostelFoodCost/updateHostelFoodCost', payload);
    setSuccessMessage('Food cost + serving time updated successfully!');

  } catch (error) {
    console.error(error);
    setErrorMessage('Failed to update food cost. Please try again.');
  }
};
const handleAddOnChange = (index, field, value) => {
  setAddOnItems(prev => {
    const updated = [...prev];
    updated[index][field] = value;
    return updated;
  });
};

const addNewAddOn = () => {
  setAddOnItems(prev => [...prev, { name: '', price: '' }]);
};

const removeAddOn = (index) => {
  setAddOnItems(prev => prev.filter((_, i) => i !== index));
};
const today = new Date().toLocaleDateString("en-US", {
  weekday: "long"
});
  return (
    <>
      {!isDialog && !location?.state?.disableHeader && <HeaderMenu />}
      <Paper elevation={3} sx={{ p: { xs: 2, sm: 4, md: 6 }, maxWidth: 1200, margin: 'auto' }}>
        
		{(successMessage || errorMessage) && (
		  <Box
			ref={alertRef}
			tabIndex={-1}
			sx={{ mb: 2, outline: "none" }}
		  >
			<Alert severity={errorMessage ? "error" : "success"}>
			  {errorMessage || successMessage}
			</Alert>
		  </Box>
		)}


        {!isDialog && (
          <Box mb={3}>
  <Typography variant="h4" fontWeight={700}>
    🍽️ Hostel Menu Management
  </Typography>
  <Typography color="text.secondary">
    Manage menu, pricing, serving time, and add-ons in one place
  </Typography>
</Box>
        )}

        <form onSubmit={handleSubmit}>
          {/* Hostel Name */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Hostel Name</InputLabel>
                <Select name="hostelName" value={formState.hostelName} onChange={handleChange} label="Hostel Name">
                  {hostelList.map((h) => (
                    <MenuItem key={h[0]} value={h[1]}>{h[1]}</MenuItem>
                  ))}
                </Select>
              </FormControl>
			  
			  		{formState.hostelName && (
  <Alert severity="info" sx={{ mt: 2 }}>
    Hostel:
    <strong> {formState.hostelName}</strong>

    <br />

    Menu Type:
    <strong>
      {menuTypeLoading ? " Loading..." : ` ${menuType}`}
    </strong>
  </Alert>
)}
            </Grid>
			
	
          </Grid>

  <Paper sx={{ p: 3, mt: 4, borderRadius: 3 }}>
  <Typography variant="h6" gutterBottom>
  {propertyType === "HOTEL"
    ? "Serving Time"
    : "Food Cost & Serving Time"}
</Typography>
  <Grid container spacing={3}>

    {/* Food Cost Inputs */}
    {propertyType !== "HOTEL" &&
[
      { key: "oneDay", label: "Per Day Cost" },
      { key: "oneMonth", label: "Monthly Cost" },
      { key: "closureFoodAdjustmentPerDay", label: "Closure Adjustment" },
      { key: "absentFoodAdjustmentPerDay", label: "Absent Adjustment" }
    ].map((item) => (
      <Grid item xs={12} sm={6} md={3} key={item.key}>
        <TextField
          fullWidth
          size="small"
          label={item.label}
          value={formState.foodCost[item.key]}
          onChange={(e) => handleCostChange(e, item.key)}
          type="number"
        />
      </Grid>
    ))}

    {/* Serving Time Title */}
    <Grid item xs={12}>
      <Typography variant="subtitle1" mt={2} fontWeight={700}>
        Serving Time (From - To)
      </Typography>
    </Grid>

    {/* Serving Time Inputs */}
    {/* Serving Time Inputs */}
{['breakfast','lunch','snacks','dinner'].map((meal) => (
  <Grid item xs={12} sm={6} key={meal}>
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={2}
        textTransform="capitalize"
      >
        {meal}
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
      >
        <TextField
          fullWidth
          size="small"
          type="time"
          label="From"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
          value={formState.servingTime[meal].from || ""}
          onChange={(e) =>
            handleServingTimeChange(meal, "from", e.target.value)
          }
        />

        <TextField
          fullWidth
          size="small"
          type="time"
          label="To"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
          value={formState.servingTime[meal].to || ""}
          onChange={(e) =>
            handleServingTimeChange(meal, "to", e.target.value)
          }
        />
      </Stack>
    </Paper>
  </Grid>
))}

    {/* ✅ Update Button (NOW INSIDE GRID) */}
    <Grid item xs={12} textAlign="right">
      <Button
        variant="contained"
        color="primary"
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          px: 3
        }}
        disabled={!checkPermission("Hostel", "Hostel Menu", "UPDATEFOODCOST")}
        onClick={handleFoodCostUpdate}
      >
        Update
      </Button>
    </Grid>

  </Grid>
</Paper>


<Paper sx={{ p: 3, mt: 4, borderRadius: 3 }}>
  <Typography variant="h6" gutterBottom>
    Today’s Add-On Items
  </Typography>

  <Typography
    variant="caption"
    color="text.secondary"
    mb={2}
    display="block"
  >
    Not included in the meal plan · Extra charges apply
  </Typography>

  <Stack spacing={2}>
    {addOnItems.map((item, index) => (
      <Paper
        key={index}
        sx={{
          p: 2,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}
      >
        <Grid container spacing={2} alignItems="center">

          {/* Item Name */}
          <Grid item xs={12} sm={5}>
            <TextField
              fullWidth
              size="small"
              label="Item Name"
              value={item.name}
              onChange={(e) =>
                handleAddOnChange(index, 'name', e.target.value)
              }
            />
          </Grid>

          {/* Price */}
          <Grid item xs={8} sm={4}>
            <TextField
              fullWidth
              size="small"
              label="Price (₹)"
              type="number"
              value={item.price}
              onChange={(e) =>
                handleAddOnChange(index, 'price', e.target.value)
              }
            />
          </Grid>

          {/* Remove Button - Icon based */}
          <Grid
            item
            xs={4}
            sm={3}
            display="flex"
            justifyContent="center"
          >
            <Button
              onClick={() => removeAddOn(index)}
              sx={{
                minWidth: 0,
                width: 40,
                height: 40,
                borderRadius: '50%',
                color: '#f44336',
                backgroundColor: '#fdecea',
                '&:hover': {
                  backgroundColor: '#f44336',
                  color: '#fff'
                }
              }}
            >
              🗑️
            </Button>
          </Grid>
        </Grid>
      </Paper>
    ))}

    {/* Add Button */}
    <Button
      variant="outlined"
      onClick={addNewAddOn}
      fullWidth
      sx={{
        maxWidth: 240,
        alignSelf: 'center',
        borderStyle: 'dashed'
      }}
    >
      ➕ Add Add-On Item
    </Button>
  </Stack>
</Paper>



<Paper sx={{ p: 3, mt: 4, borderRadius: 3 }}>
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mb={2}
  >
    <Typography variant="h6">
      Menu Configuration
    </Typography>

    <Chip
      label={menuType}
      color={menuType === "WEEKLY" ? "primary" : "success"}
      variant="filled"
    />
  </Box>

  <Typography variant="body2" color="text.secondary">
    {menuType === "WEEKLY"
      ? "Students will see a day-wise menu schedule."
      : "Students will see the food options generally offered by the hostel. Actual meals may vary from day to day."}
  </Typography>
</Paper>



        {/* Daily Menu (Responsive) */}
{menuType === "WEEKLY" &&
 propertyType !== "HOTEL" && (
  <Paper sx={{ p: 3, mt: 4, borderRadius: 3 }}>
  <Typography variant="h6" gutterBottom>Daily Menu</Typography>

  {/* Desktop Table */}
  <Box sx={{ display: { xs: "none", md: "block" } }}>
    <TableContainer sx={{ maxHeight: 600, border:'1px solid #ddd', borderRadius:1 }}>
      <Table stickyHeader>
        <TableHead>
  <TableRow>
    <TableCell sx={{ fontWeight: 700 }}>Day</TableCell>
    <TableCell sx={{ fontWeight: 700 }}>🌅 Breakfast</TableCell>
    <TableCell sx={{ fontWeight: 700 }}>🍛 Lunch</TableCell>
    <TableCell sx={{ fontWeight: 700 }}>☕ Snacks</TableCell>
    <TableCell sx={{ fontWeight: 700 }}>🌙 Dinner</TableCell>
  </TableRow>
</TableHead>
        <TableBody>
          {Object.keys(formState.dailyMenu).map(day=>(
<TableRow
  key={day}
  sx={{
    backgroundColor:
      day === today ? "#fff8e1" : "inherit"
  }}
>
  <TableCell
    sx={{
      position: "sticky",
      left: 0,
      background:
        day === today ? "#fff8e1" : "#fff",
      zIndex: 2,
      fontWeight: 700,
      borderLeft:
        day === today
          ? "4px solid #ff9800"
          : "none"
    }}
  >
    {day}
  </TableCell>

  {["breakfast","lunch","snacks","dinner"].map(meal => (
    <TableCell key={meal}>
      <TextField
        fullWidth
        size="small"
        value={formState.dailyMenu[day][meal]}
        onChange={(e) =>
          handleMenuChange(day, meal, e.target.value)
        }
      />
    </TableCell>
  ))}
</TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>

  {/* Mobile Card View */}
  <Box sx={{ display: { xs: "block", md: "none" } }}>
    {Object.keys(formState.dailyMenu).map(day => (
      <Box
  key={day}
  p={2}
  mb={2}
  borderRadius={2}
  border={
    day === today
      ? "2px solid #ff9800"
      : "1px solid #ddd"
  }
  bgcolor={
    day === today
      ? "#fff8e1"
      : "#fff"
  }
>
        <Typography fontWeight={700} mb={2}>{day}</Typography>

        {["breakfast","lunch","snacks","dinner"].map(meal=>(
          <Box key={meal} mb={2}>
            <Typography fontSize={14} mb={1} textTransform="capitalize">{meal}</Typography>
            <TextField
              fullWidth size="small"
              value={formState.dailyMenu[day][meal]}
              onChange={e=>handleMenuChange(day, meal, e.target.value)}
            />
          </Box>
        ))}
      </Box>
    ))}
  </Box>

</Paper>
)}

{(menuType === "STANDARD" || propertyType === "HOTEL") && (
  <Paper sx={{ p: 3, mt: 4, borderRadius: 3 }}>
    <Typography variant="h6" gutterBottom>
  {propertyType === "HOTEL"
    ? "Available Food Options"
    : "Standard Menu"}
</Typography>

   <Typography
  variant="body2"
  color="text.secondary"
  sx={{ mb: 3 }}
>
  {propertyType === "HOTEL"
    ? "Food items available in the property."
    : "Same menu will be shown every day."}
</Typography>

    <Grid container spacing={2}>
      {["breakfast", "lunch", "snacks", "dinner"].map((meal) => (
        <Grid item xs={12} md={6} key={meal}>
          <TextField
            fullWidth
            label={meal.charAt(0).toUpperCase() + meal.slice(1)}
            value={defaultMenu[meal]}
            onChange={(e) =>
              setDefaultMenu((prev) => ({
                ...prev,
                [meal]: e.target.value
              }))
            }
          />
        </Grid>
      ))}
    </Grid>
  </Paper>
)}

          {/* Action Buttons */}
         <Box
  sx={{
    position: "sticky",
    bottom: 0,
    background: "#fff",
    py: 2,
    borderTop: "1px solid #eee",
    zIndex: 100
  }}
>
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={2}
    justifyContent="center"
  >
    <Button
      disabled={
        saving ||
        !checkPermission(
          "Hostel",
          "Hostel Menu",
          "UPDATE"
        )
      }
      type="submit"
      variant="contained"
      color="primary"
      sx={{ minWidth: 140 }}
    >
      {saving ? "Saving..." : "Update Menu"}
    </Button>

    <Button
      onClick={onClose}
      variant="outlined"
      color="secondary"
      sx={{ minWidth: 140 }}
    >
      Close
    </Button>
  </Stack>
</Box>
        </form>
      </Paper>
	  
	  <Snackbar
  open={openSnackbar}
  autoHideDuration={3000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right"
  }}
>
  <Alert
    onClose={() => setOpenSnackbar(false)}
    severity="success"
    variant="filled"
  >
    Menu updated successfully
  </Alert>
</Snackbar>
    </>
  );
};

export default CreateHostelMenu;
